<template>
  <li
    class="saas-header__sub-nav-item"
    :class="description ? 'saas-header__sub-nav-item--with-description' : ''"
  >
    <component
      :is="linkComponent"
      :to="to || undefined"
      v-bind="
        to
          ? {}
          : {
              href: href,
              target: target,
              rel: rel,
            }
      "
      class="saas-header__sub-nav-link"
    >
      <div>
        <div class="saas-header__sub-nav-icon">
          <i :class="icon"></i>
        </div>
      </div>
      <div class="saas-header__sub-nav-name">
        <div class="saas-header__sub-nav-name-title">
          {{ title }}
        </div>
        <div v-if="description" class="saas-header__sub-nav-name-description">
          {{ description }}
        </div>
      </div>
    </component>
  </li>
</template>

<script>
import { resolveComponent } from 'vue'

export default {
  name: 'HeaderSubNavItem',
  computed: {
    linkComponent() {
      return this.to ? resolveComponent('NuxtLink') : 'a'
    },
  },
  props: {
    to: {
      required: false,
      type: [String, Object],
      default: '',
    },
    href: {
      required: false,
      type: String,
      default: '',
    },
    target: {
      required: false,
      type: String,
      default: '',
    },
    rel: {
      required: false,
      type: String,
      default: '',
    },
    icon: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    description: {
      required: false,
      type: String,
      default: '',
    },
  },
}
</script>
